import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
      retry: (failureCount, error: unknown) => {
        if ((error as { code?: string })?.code === '401') return false;
        if ((error as { code?: string })?.code === '400') return false;

        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
